import React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import DraggableFleet from './draggable-fleet';
import TrashButton from './trash-button';
import _range from 'lodash/range';
import classNames from 'classnames';

import { Fleet } from '../priority-configuration';

const reorder = <T,>(list: T[], startIndex: number, endIndex: number): T[] => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
};

interface Props {
	fleets: Fleet[];
	readOnly?: boolean;
	onChange: (fleets: Fleet[]) => void;
	translations?: Translations;
}

export interface Translations {
	internalFleetName: string;
}

const Fleets: React.FC<Props> = ({ fleets, onChange, translations, readOnly }) => {
	const onDragEnd = result => {
		// dropped outside the list
		if (!result.destination) {
			return;
		}
		const items = reorder<Fleet>(fleets, result.source.index, result.destination.index);
		onChange(items);
	};

	const removeFleet = index => {
		const newFleetIds = [...fleets];
		newFleetIds.splice(index, 1);
		onChange(newFleetIds);
	};

	return (
		<div className={classNames('fleets', { 'drag-disabled': readOnly })}>
			<div className="numbers fake-grid-column">
				{_range(1, fleets.length + 1).map(index => (
					<div className="number-cell fake-grid-row" key={index}>
						<div className="number">{index}</div>
					</div>
				))}
			</div>
			<DragDropContext onDragEnd={onDragEnd}>
				<Droppable droppableId="droppable">
					{provided => (
						<div
							{...provided.droppableProps}
							ref={provided.innerRef}
							className="draggable-area fake-grid-column"
						>
							{fleets.map((fleet, index) => {
								return (
									<DraggableFleet
										key={fleet.id}
										fleet={fleet}
										index={index}
										isDragDisabled={readOnly}
										translations={translations}
									/>
								);
							})}
							{provided.placeholder}
						</div>
					)}
				</Droppable>
			</DragDropContext>
			<div className="trash-area fake-grid-column">
				{fleets.map((fleet, index) => (
					<TrashButton
						onClick={() => removeFleet(index)}
						className="fake-grid-row"
						key={index}
						disabled={readOnly}
					/>
				))}
			</div>
		</div>
	);
};

export default Fleets;
